import { Box, Container, Grid, IconButton, useTheme } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { GetHistoryForm, GetHistoryList } from "store/api/historyWallet";
import { useEffect, useState } from "react";

import BoxMarginHistory from "./Component/BoxMarginHistory";
import { Filter } from "assets/Icon";
import FilterMarginHistory from "./Component/FilterMarginHistory";
import MarginHistoryTabs from "./Component/MarginHistoryTabs";
import Pagination from "components/Pagination";
import TableMarginHistory from "./Component/TableMarginHistory";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import { formatDateToJalali } from "utils/helpers/time";

function MarginHistory() {
  const theme = useTheme();
  const notify = useNotify();
  const isMobileView = useIsMobileView();
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState();
  const [historyFormData, setHistoryFormData] = useState();
  const [historyList, setHistoryList] = useState();

  const pageNumber = +searchParams.get("page") || 1;
  const pageSize = +searchParams.get("perPage") || 10;
  const typeId = +searchParams.get("typeId") || 0;

  const defaultValues = {
    dateFrom: "",
    dateTo: "",
    repayId: 0,
    transferId: 0,
    coinId: -1,
  };

  const methods = useForm({ defaultValues });
  const { watch } = methods;

  const dateFrom = watch("dateFrom");
  const dateTo = watch("dateTo");
  const repayId = watch("repayId");
  const transferId = watch("transferId");
  const coinId = watch("coinId");

  const getHistoryForm = async () => {
    try {
      const { data } = await http.get(GetHistoryForm);

      setHistoryFormData(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const getHistoryList = async ({ pageNumber, pageSize }) => {
    try {
      setLoading(true);
      const { data } = await http.get(
        GetHistoryList({
          typeId,
          coinId,
          dateFrom: formatDateToJalali(dateFrom),
          dateTo: formatDateToJalali(dateTo),
          transferId,
          repayId,
          pageNumber,
          pageSize,
        })
      );

      setHistoryList(data);
      setLoading(false);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleChangeHistoryTab = (_, newValue) => {
    setSearchParams({
      typeId: newValue,
    });
  };

  const handleChangePaginate = ({ page, perPage }) => {
    getHistoryList({ pageNumber: page, pageSize: perPage });
  };

  useEffect(() => {
    getHistoryForm();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getHistoryList({ pageSize, pageNumber });
    // eslint-disable-next-line
  }, [repayId, transferId, coinId, dateFrom, dateTo, typeId]);

  return (
    <Container maxWidth="100%">
      <Grid container>
        <MarginHistoryTabs
          historyFormData={historyFormData}
          handleChange={handleChangeHistoryTab}
          typeId={typeId}
        />

        <Grid item xs={12}>
          <Box display="flex" flexDirection="row-reverse" mb={2}>
            <IconButton
              onClick={() => {
                setShowFilter((v) => !v);
              }}
              aria-label="filter"
            >
              <Filter color={theme.palette.text.main} />
            </IconButton>
          </Box>

          {showFilter && (
            <FormProvider {...methods}>
              <form>
                <FilterMarginHistory
                  typeId={typeId}
                  historyFormData={historyFormData}
                />
              </form>
            </FormProvider>
          )}
        </Grid>

        <Grid item xs={12}>
          {isMobileView ? (
            <>
              {historyList?.data?.map((marginHistoryItem) => (
                <BoxMarginHistory marginHistoryItem={marginHistoryItem} />
              ))}
            </>
          ) : (
            <>
              {!loading ? (
                <TableMarginHistory historyList={historyList} />
              ) : (
                <TableSkeleton />
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Pagination
            count={historyList?.totalPages}
            perPage={historyList?.pageSize}
            onChange={handleChangePaginate}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default MarginHistory;
